export const locale = {
    lang: "es",
    data: {
        TAB: {
            Status: "Estado",
            Data: "Datos",
            Alarms: "Alarmas",
            Events: "Eventos",
            Info: "Info",
            Report: "Informe",
            Files: "Archivos",
        },
        DEVICES: {
            ID: "ID",
            Name: "Nombre",
            Active: "Activo",
            LastData: "Últimos datos",
            Address: "Dirección",
            Devices: "Dispositivos",
        },
        DEVICE: {
            NoiseLevel: "Nivel Ruido",
            Limit: "Limite:",
            Info: "Información",
            Name: "Nombre",
            SerialNumber: "Número de Série",
            Location: "Localización",
            Latitude: "Latitud",
            Longitude: "Longitud",
            NoGPSData: "Datos GPS inváldios",
            Comments: "Comentarios",
            Last15Minutes: "Últimos 15 Minutos",
            LastHour: "Última Hora",
            Last4Hours: "Últimas 4 Horas",
            Last12Hours: "Últimas 12 Horas",
            Last24Hours: "Últimas 24 Horas",
            StartDate: "Fecha de Inicio",
            EndDate: "Fecha Final",
            Data: "Datos",
            DateRange: "Intervalo",
            DataAggregation: "Media",
            NoAggregation: "Valors Puntuales",
            Minutes5: "5 Minutos",
            LiveUpdate: "Actualización en Vivo",
            ShowL10: "Mostrar L10",
            ShowL90: "Mostrar L90",
            Custom: "Custom",
            Download: "Descargar Datos CSV",
            StartTime: "Hora Inicio",
            EndTime: "Hora Fin",
            Image: "Imagen",
            DropFiles: "Arrastre la imagen aquí",
            RemoveImage: "Borra Imagen",
            Picture: "Imagen",
            BaseName: "Dispositivo",
            LF010PeriodLimits: "Límites LF010",
            LF010PeriodLimitsHelp: "Límites de emisión guardados y periodos de proyecto asignados.",
            LF010DevicePeriod: "Periodo LF010",
            LF010Limit: "Límite",
            LF010SectionTitle: "Límites",
            LF010SectionHelp: "Límites actuales por periodo del LF010 y el historial de cambios registrados.",
            LF010LimitHistory: "Historial de límites",
            LF010LimitHistoryHelp: "Cambios anteriores de límites LF010 recibidos del dispositivo.",
            LF010LimitHistoryEmpty: "Todavía no se han registrado cambios de límites LF010.",
            LF010PreviousLimit: "Límite anterior",
            LF010NewLimit: "Nuevo límite",
            LF010ChangedAt: "Fecha de cambio",
            ProjectPeriod: "Periodo del proyecto",
            NotMapped: "Sin asignar",
            UploadFile: "Subir Archivo",
            Minutes30: "30 Minutos",
            ShowSpectrum: "Mostrar Espectro",
        },
        ALARM: {
            ID: "Id",
            Name: "Nombre",
            Description: "Descripción",
            TimeWindow: "Ventana de tiempo",
            Threshold: "Umbral",
            Limit: "Límite",
            LimitMode: "Modo del límite",
            LimitModeWholeDay: "Todo el día",
            LimitModePeriods: "Por periodos",
            Severity: "Severidad",
            Field: "Campo",
            Remove: "Eliminar",
            Duplicate: "Duplicar",
            time_window_instant: "Instant",
            time_window_bucket_5: "Bucket 5 minutos",
            threshold_cross_over: "Cruzar ENCIMA",
            threshold_cross_below: "Cruzar ABAJO",
            ADD: "AÑADIR",
            SAVE: "GUARDAR",
            CANCEL: "CANCELAR",
            AlarmDetail: "Detalle de alarma",
            NewAlarm: "Nueva Alarma",
            Notify: "Notificar",
            Notification: "Notificación",
            Silent: "Silenciosa",
            NeedACK: "Requiere ACK",
            IgnoredDevices: "Dispositivos ignorados",
            NewNotificationItem: "email/teléfono",
            NewNotificationItemEmailOnly: "email",
            NotificationChannels: "Canales de notificación",
            NotificationChannelsEmpty: "Todavía no hay canales de notificación del proyecto. Créelos en la administración del proyecto.",
            LegacyNotificationList: "Destinatarios legacy mantenidos por compatibilidad",
            SimOrImei: "SIM o IMEI",
            LastCalibrationDate: "Fecha de última calibración",
            ProjectAlarm: "Alarmas de proyecto",
            AlarmDeleteTitle: "Alerta",
            AlarmDeleteMessage: "Esta alarma tiene {{activeEvents}} eventos activos. \nSeguro que la quieres eliminar?",
        },
        SEVERITY: {
            alarm: "Alarma",
            info: "Información",
            success: "Éxito",
            warning: "Advertencia",
        },
        FIELD: {
            sound_pressure_level: "Nivel Ruido (dBA)",
            sound_pressure_level_c: "Nivel Ruido (dBC)",
            sound_pressure_level_1m: "Nivel Ruido (dBA, 1 min)",
            sound_pressure_level_1m_sensor_2: "Sound Pressure (Sensor 2)",
            sound_pressure_level_c_1m: "Nivel Ruido (dBC, 1 min)",
            sound_pressure_level_c_minus_a: "dBC - dBA",
            rolling_5s: "Rolling 5 segundos (dBA)",
            rolling_5s_c: "Rolling 5 segundos (dBC)",
            rolling_5: "Rolling 5 minutos (dBA)",
            rolling_5_c: "Rolling 5 minutos (dBC)",
            rolling_30: "Rolling 30 minutos (dBA)",
            rolling_30_c: "Rolling 30 minutos (dBC)",
            battery: "Batería",
            power_supply_status: "Fuente Alimentación",
            spectrum_13_octave: "Espectro 1/3 Octava",
            temperature: "Temperatura Ext.",
            overload: "Sobrecarga",
            underrange: "Underrange",
            spectrum_13_octave_1m: "Espectro 1/3 Octava (1 min)",
            wifi_signal_level: "Señal WiFi",
            cellullar_signal_level: "Señal Cellular",
            free_storage: "Espacio Libre",
        },
        REPORT: {
            General: "Datos Generales",
            Device: "Equipo / Número de Serie",
            Address: "Dirección",
            Comments: "Comentarios",
            Register: "Registro",
            GenerateReport: "Generar Informe",
            Dates: "Fechas",
            GPS: "Coordenadas GPS",
            Photo: "Foto",
            ProjectName: "Nombre del Proyecto",
            RegisteredParameters: "Parámetros Registrados",
            Graph: "Gráfica",
            Observations: "Observaciones",
            CustomAlarm: "Límite Personalizado",
            Limits: "Límites",
            Fields: "Campos",
            Map: "Mapa",
            DataSetup: "Configuración de Datos",
            ReportOptions: "Opciones del Informe",
            Options: "Opciones",
            Interval: "Intervalo",
            AWeighting: "A",
            CWeighting: "C",
            Color: "Color",
            LineStyle: "Línea",
            Interval1s: "1s",
            Interval5sRolling: "5s rolling",
            Interval5minBucket: "5min (bucket)",
            Interval5minRolling: "5min rolling max",
            Interval30minRolling: "30min rolling max",
            LineStyleSolid: "Sólida",
            LineStyleDashed: "Discontinua",
            LineStyleDotted: "Punteada",
            DeviceComments: "Comentarios del Equipo",
            PeriodBands: "Mostrar bandas de período",
            LAeq1s: "LAeq 1s",
            LCeq1s: "LCeq 1s",
            LAeq5sRolling: "LAeq 5s rolling",
            LCeq5sRolling: "LCeq 5s rolling",
            LAeq5minBucket: "LAeq 5min (bucket)",
            LCeq5minBucket: "LCeq 5min (bucket)",
            LAeq5minRolling: "LAeq 5min rolling (max)",
            LCeq5minRolling: "LCeq 5min rolling (max)",
            LAeq30minRolling: "LAeq 30min rolling (max)",
            LCeq30minRolling: "LCeq 30min rolling (max)",
            LAqe30: "LAeq 30min",
            LAqe5: "LAeq 5min",
            LAqe1: "LAeq 1seg",
            LAqe5s: "LAeq 5seg",
            YAxisRange: "Rango Eje Y",
            YAxisMin: "Mínimo",
            YAxisMax: "Máximo",
        },
        FILE: {
            Name: "Nombre",
            UploadDate: "Fecha de Subida",
            Status: "Estado",
            DropFile: "Arrastre el archivo aquí",
            uploaded: "Subido",
            processing: "Procesando",
            processed: "Procesado",
        },
    },
};
